import request from 'graphql-request';
import { Endpoint } from '../../endpoint';
import { graphql } from '../../../gql/api-ai-tools/gql';
import { AiToolQuery } from '../../../gql/api-ai-tools/graphql';
import { IResponseData } from '../../../typings/common';
import { IUserDataModel } from '../../../typings/userData';
import { userDataModel } from '../../../utilities/models/userData';

const query = graphql(/* GraphQL */ `
  query AiTools {
    aiTools {
      userDataAiBrainTools {
        userId
        clientHash
        hasSubscription
        freePremiumGenAvailableAttempts
        status {
          code
          message
        }
      }
    }
  }
`);

export const userData = async (): Promise<IResponseData<IUserDataModel>> => {
  const response = await request<AiToolQuery>(
    Endpoint.GRAPHQL_EDUSSON_AI_TOOL,
    query
  );

  const result = userDataModel(response.aiTools?.userDataAiBrainTools);

  return {
    data: result,
    status: response.aiTools?.userDataAiBrainTools?.status?.code,
    message: response.aiTools?.userDataAiBrainTools?.status?.message,
  };
};
